import { ANALYTICS_EVENT_CLICK } from '../utils/constants'
import { setAnalyticsEvent } from './Analytics'

export const setFilterCategoryAnalyticsEvent = (categoryName: string): void => {
  const event = {
    name: `${categoryName} - filter`,
    action: ANALYTICS_EVENT_CLICK,
    details: '',
  }

  setAnalyticsEvent(event)
}
